var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg016Whistle = function Svg016Whistle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451 225.993h-30v-60H271v30h-30v-30h-53.73c-46.923 0-92.053 20.37-121.392 54.069C44.621 210.529 30 189.86 30 165.993c0-33.091 26.909-60 60-60h151c33.091 0 60-26.909 60-60h-30c0 16.538-13.462 30-30 30H90c-49.629 0-90 40.371-90 90 0 33.831 19.169 64.092 48.175 79.413-11.338 20.493-18.045 44.084-18.181 69.959-.439 83.676 68.487 150.643 150.859 150.643 78.157 0 150.69-61.62 150.19-152.432L512 283.708V165.993h-61zm-270 150c-33.091 0-60-26.909-60-60s26.909-60 60-60 60 26.909 60 60-26.909 60-60 60"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 315.993,
    r: 30
  })));
};
export default Svg016Whistle;